// extracted by mini-css-extract-plugin
export default {"tasks":"oO-z","task":"pO-z","svg":"qO-z","text":"rO-z"};